module.exports = __webpack_public_path__ + "img/17.7fb2e471.jpg";